var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 7,
  r: 4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 8v6M22 11h-6"
})));
export default SvgAddUser;